<template>
  <div>
    <f7-popup
      class="cAddressPopup-container"
      :opened="show"
      animated
      ref="cAddressPopup"
      @popup:closed="popupCloseHandle"
    >
      <f7-card class="cAddressPopup-main">
        <div class="cAddressPopup-list">
          <li
            v-for="(item, index) in selectdata"
            :key="index"
            @click="handelSelect(item)"
            :class="{ 'last-item': index == selectdata.length - 1 }"
          >
            <span class="name"> {{ item.value }}</span>
            <p
              class="no-select"
              :class="item.isActive ? 'ok-select' : 'no-select'"
            >
              <span></span>
            </p>
          </li>
        </div>
        <div class="cAddressPopup-btn">
          <p @click="cancelconfirm(false)">キャンセル</p>
          <p @click="cancelconfirm(true)" class="btn-sure">OK</p>
        </div>
      </f7-card>
    </f7-popup>
  </div>
</template>

<script>
export default {
  props: ['show', 'selectdata'],
  data() {
    return {};
  },

  methods: {
    // 选择
    handelSelect(item) {
      this.$emit('clickselect', item);
    },
    // 关闭
    popupCloseHandle() {
      this.$emit('clickclose');
    },
    // 确定
    cancelconfirm(falg) {
      if (falg) {
        var status = this.selectdata.find((ite) => {
          return ite.isActive;
        });
        if (status) {
          this.$emit('clickcancel', falg);
          this.popupCloseHandle();
        } else {
          this.showAlert();
        }
      } else {
        this.$emit('clickcancel', falg);
        this.popupCloseHandle();
      }
    },
    // 提示语言
    showAlert() {
      this.$cErrorDialog({
        title: '',
        left: 'cancel',
        right: 'OK',
        content: 'いずれか一つを選択してください',
        cancelBtn: false //这个是启用取消按钮，
      });
    }
  }
};
</script>
<style lang="less"  scoped>
  @media screen and (max-width:768px) {
    .cAddressPopup-container{
      background: transparent;
    }
  }
  @media screen and (min-width:769px) {
    .cAddressPopup-container{
      .card{
        box-shadow:none;
        -webkit-box-shadow:none;
        width:100%;
        height:100% !important;
      }
      //修改滚动条样式
      .cAddressPopup-list::-webkit-scrollbar{
        width:5px;
        height:5px;
      }
      .cAddressPopup-list::-webkit-scrollbar-track{
        background: rgb(239, 239, 239);
        border-radius:2px;
      }
      .cAddressPopup-list::-webkit-scrollbar-thumb{
        background: #bfbfbf;
        border-radius:5px;
      }
      .cAddressPopup-list::-webkit-scrollbar-thumb:hover{
        background: #333;
      }
      .cAddressPopup-list::-webkit-scrollbar-corner{
        background: #179a16;
      }
    }
  }
.cAddressPopup-container {
  position: fixed;
  /*background: transparent;*/
  padding: 0 15px;
  .cAddressPopup-main {
    position: relative;
    height: 528px;
    top: 50%;
    transform: translateY(-50%);
    background-color: #fff;
    border-radius: 8px;
    padding: 15px;
    display: flex;
    flex-direction: column;
    .cAddressPopup-list {
      flex: 1;
      overflow-y: scroll;
      li {
        font-size: 16px;
        min-height: 44px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #ececec;
        padding: 10px 15px 10px 1px;
        box-sizing: border-box;
        cursor: pointer;
        .name {
          flex: 1;
          line-height: 22px;
          margin-right: 2px;
        }
        .no-select {
          width: 21px;
          height: 21px;
          border-radius: 50%;
          border: 1px solid #a7a7a7;
          box-sizing: border-box;
        }
        .ok-select {
          width: 21px;
          height: 21px;
          border-radius: 50%;
          border: 1px solid var(--maincolor);
          display: flex;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
          span {
            display: inline-block;
            width: 13px;
            height: 13px;
            border-radius: 50%;
            background: var(--maincolor);
          }
        }
      }
      .last-item {
        border: none;
      }
    }
    .cAddressPopup-btn {
      width: 100%;
      font-size: 14px;
      height: 40px;
      display: flex;
      margin-bottom: 10px;
      margin-top: 14px;
      cursor: pointer;
      p {
        width: 50%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #7a7a7a;
        border: 1px solid;
        margin: auto 0.1rem;
      }
      .btn-sure {
        color: var(--maincolor);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Select/cSinglePopup.vue